

<template>
 

  <div class="container put-right" style="direction:rtl">

      <h3 class="heading" style="display:initial;margin-left:2rem">نوع الهوية</h3>
        <form style="display:initial;">
 <router-link to="/AddIdentity"> <button type="button" class="btn btn-primary">اضافة</button> </router-link>
      </form>


<div class="container menu">
<div class="table-responsive">
<table class="table">
  <thead>
    <tr>
      <th scope="col"> الترتيب</th>
      <th scope="col">نوع الهوية</th>
     
    </tr>
  </thead>
  <tbody>
    
    <tr v-for="keey in formdata2" :key="keey.id" >
      
      <th scope="row" >{{keey.id}}</th>
      <td>       {{keey.name}} </td>
     
    
    </tr>
   
  </tbody>
</table>
</div>
  
</div>
</div>


           


   

</template>

<script>
import  geturl  from "@/comp/geturl";

export default {
name:"IdentityView",
data(){
  return{
     formdata2:[],    
  }
},
mounted() {
  
 
    
       fetch(geturl()+"complaints/identity", {
      
      headers: {"Content-Type": "application/json"},
      })
      .then(res => res.json())
      .then(data => {this.formdata2 = data           
      })
    }
}
</script>

<style>

</style>
